import { sportsColor } from '@/lib/sports-market';
import type { SportsMoneylineDto } from '@/lib/models';

export interface SportsTeamLegendProps {
  /** The event's moneyline block — one legend row per team/answer. */
  moneyline: SportsMoneylineDto;
}

/**
 * The team stat legend under the event header (Figma 6221): one row per moneyline
 * answer — a team-coloured dot, the Yes chance, and the team's full name. Uses the
 * Plaee team colour (fallback to the side tone); the name is always the full name
 * (never the abbreviation), matching the chart line colours below it.
 */
export function SportsTeamLegend({ moneyline }: SportsTeamLegendProps) {
  return (
    <div className="flex flex-col gap-1">
      {moneyline.outcomes.map((o) => {
        const color = sportsColor(o.color, o.side);
        const pct = o.chancePercent == null ? '—' : `${o.chancePercent}%`;
        return (
          <div key={o.outcomeId} className="flex items-center gap-1">
            <span className="size-1 shrink-0 rounded-full" style={{ backgroundColor: color }} aria-hidden />
            <p className="text-[16px] leading-normal tracking-[-0.32px] text-ink">
              <span className="font-medium" style={{ color }}>
                {pct}
              </span>
              <span>{` ${o.label}`}</span>
            </p>
          </div>
        );
      })}
    </div>
  );
}
